import { render, staticRenderFns } from "./snackbar.component.vue?vue&type=template&id=0dc8715c&scoped=true&"
import script from "./snackbar.component.vue?vue&type=script&lang=ts&"
export * from "./snackbar.component.vue?vue&type=script&lang=ts&"
import style0 from "./snackbar.component.vue?vue&type=style&index=0&id=0dc8715c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc8715c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VIcon,VSnackbar})
